import React from 'react';
import SafeHTMLRender from '../../app/shared/SafeHTMLRender';
import { PassportNonce } from '../../lib/constants';

type ErrorBlockProps = {
  errorMessage: string,
  classname?: string,
  id?: string
}

const ErrorBlock:React.FC<ErrorBlockProps> = ({ errorMessage, classname = '', id }) => {
  return (
    <div id={id}>
      <SafeHTMLRender
        nonce={PassportNonce.RICH_TEXT}
        html={errorMessage}
        className={`${classname} width-full bg-white text-error py-1 font-medium font-size-11px break-words bg-opacity-0 `}
      />
    </div>
  );
};

export default ErrorBlock;
